// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"235d0dca","539":"f3f10413","671":"397cc862","815":"17a0fbf3","896":"d095f9a3","920":"67f9bb87"}[chunkId] + ".chunk.js";
};